<template>
  <footer>
		<div class="content">
			<div class="info">
				<ul>
					<li><strong>关于我们</strong></li>
					<li><a href="" target="_blank">公司介绍</a></li>
					<li><a href="" target="_blank">企业文化</a></li>
					<li><a href="" target="_blank">专利认证</a></li>
				</ul>
				<ul>
					<li><strong>技术创新</strong></li>
					<li><a href="" target="_blank">本体激励电机特点</a></li>
					<li><a href="" target="_blank">控制系统解析</a></li>
				</ul>
				<ul>
					<li><strong>应用案例</strong></li>
					<li><a href="" target="_blank">风机类</a></li>
					<li><a href="" target="_blank">泵类</a></li>
					<li><a href="" target="_blank">搅拌类</a></li>
					<li><a href="" target="_blank">磨机类</a></li>
				</ul>
				<ul>
					<li><strong>新闻中心</strong></li>
					<li><a href="" target="_blank">企业新闻</a></li>
					<li><a href="" target="_blank">行业动态</a></li>
				</ul>
				<ul>
					<li><strong>联系我们</strong></li>
					<li><a href="" target="_blank">联系方式</a></li>
				</ul>
			</div>

			<div class="phone">
				<div>
					<span>联系电话</span>
					<strong>0533-5356548</strong>
				</div>
				<p>©2023 山东中喆德元智能装备有限公司 <a href="http://beian.miit.gov.cn/" style="color: #ffffff">鲁ICP备2023010886号</a></p>
			</div>
		</div>
	</footer>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
	footer{
		width: 100%;
		background: #222;
		padding-top: 75px;

		.info{
			width: 100%;
			background: url('../images/logo_foot.png') right no-repeat;
			display: flex;

			ul{
				width: 190px;

				strong{
					color: #fff;
					font-size: 20px;
					margin-bottom: 25px;
					display: block;
				};
				a{
					color: #fff;
					line-height: 35px;
					opacity: 0.35;
				}
			}
		}
		.phone{
			color: #fff;
			width: 100%;
			border-top: 1px solid #393939;
			padding: 50px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&>div{
				span{
					line-height: 30px;
					opacity: 0.35;
					display: block;
				}
				strong{
					font-size: 32px;
				}
			}
			p{
				opacity: 0.35;
			}
		}
	}
</style>
